import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['branch', 'map'];

  connect() {
    if (window.ymaps) {
      this.initMap();
    } else {
      this.loadScript();
    }
  }

  loadScript() {
    let script = document.createElement('script');
    const prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if(!isAbort) {
          this.initMap();
        }
      }
    };

    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&csp=true';
    prior.parentNode.insertBefore(script, prior);
  }

  initMap() {
    let controller = this;

    // debugger;
    ymaps.ready(() => {
      const map = new ymaps.Map(this.mapTarget.id, {
        center: [55.768826, 37.599772],
        zoom: 4
      });
      map.controls.add('zoomControl', { top: 75, left: 5 });
      map.behaviors.disable('scrollZoom');
      map.controls.remove('searchControl');

      const boundsCollection = new ymaps.GeoObjectCollection();
      const invisibleCollection = new ymaps.GeoObjectCollection();

      controller.branchTargets.forEach((branch) => {
        if (branch.dataset.address){
          const placemark = new ymaps.Placemark(
            [branch.dataset.latitude, branch.dataset.longitude],
            {
              balloonContentHeader: branch.dataset.name,
              balloonContentBody: branch.dataset.address,
              balloonContentFooter: `${branch.dataset.phone} 
                                   <a href="mailto:${branch.dataset.email}">${branch.dataset.email}</a>`,
              hintContent: branch.dataset.name
            },
            {
              openEmptyBalloon: true
            }
          );

          if (branch.dataset.visible) {
            boundsCollection.add(placemark);
          } else {
            invisibleCollection.add(placemark);
          }
        }
      });

      // debugger;
      map.geoObjects.add(boundsCollection);
      map.setBounds(boundsCollection.getBounds());

      map.geoObjects.add(invisibleCollection);

      this.map = map;

    });
  }

  show(event) {
    this.branchTargets.forEach((branch) => this.closeBranch(branch));

    this.openBranch(event.currentTarget.closest('[data-target="shared--branches-map.branch"]'));
  }

  openBranch(branch) {
    branch.classList.add('is-active');

    if (branch.dataset.address) {
      this.map.panTo([parseFloat(branch.dataset.latitude), parseFloat(branch.dataset.longitude)], {
        checkZoomRange: true,
        delay: 1500,
        flying: true
      });
    }
  }

  closeBranch(branch) {
    branch.classList.remove('is-active');
  }
}
